import React from 'react'
import classnames from 'classnames'
import { CELL_COLOR } from '../cellColor'

/** Em-dash placeholder for null / not-applicable table cells. */
export const NullDash: React.FC<{ className?: string }> = ({ className }) => (
  <span className={classnames(CELL_COLOR.null, className)}>—</span>
)

export default NullDash
